// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

import { createElement } from "react";
import { getAsset } from "../getAsset";

export class Gallery extends EventTarget {
  constructor() {
    super();
    this.activeType = null;
    this.gallery = document.createElement("div");
    this.gallery.classList.add("gallery");
    this.galleryBox = document.createElement("div");
    this.galleryBox.classList.add("galleryBox");
    this.galleryBox.addEventListener("transitionend", (e) => {
      if (e.propertyName === "transform") {
        let style = window.getComputedStyle(this.galleryBox);
        let transform = style.transform;
        let values = transform.split("(")[1].split(")")[0].split(",");
        let scaleX = parseFloat(values[0]);
        if (scaleX == 0) {
          this.gallery.style.display = "none";
        }
      }
    });
    this.gallery.appendChild(this.galleryBox);
    let title = document.createElement("div");
    title.style.fontSize = "24px";
    title.innerText = "Material Gallery";
    this.galleryBox.appendChild(title);
    this.categories = document.createElement("div");
    this.categories.classList.add("galleryCategories");
    this.galleryBox.appendChild(this.categories);
    let img = document.createElement("img");
    img.id = "exitGallery";
    img.src = getAsset("close.svg", "images");
    img.style.position = "absolute";
    img.style.right = "10px";
    img.style.top = "10px";
    img.style.height = "20px";
    // img.addEventListener("click", ()=>{
    //     console.log("Exit");
    //     // this.gallery.style.display="none"
    // });
    this.galleryBox.appendChild(img);
  }
  data(json) {
    console.log(json);
    console.log(json.length);
    for (let i = 0; i < json.length; i++) {
      let category = document.createElement("div");
      category.classList.add("galleryCategory");
      this.categories.appendChild(category);
      let bar = document.createElement("div");
      bar.id = json[i].type;
      if (i == 0) {
        this.activeType = bar.id;
      }
      bar.addEventListener("click", (e) => {
        console.log(e.target.id);
      });
      bar.classList.add("galleryCategoryBar");
      category.appendChild(bar);
      bar.innerText = json[i].type;
      let list = document.createElement("div");
      list.classList.add("galleryCategoryList");
      category.appendChild(list);
      let images = json[i].images;
      for (let j = 0; j < images.length; j++) {
        let img = document.createElement("img");
        // img.id = "/materials/"+json[i].type+"/"+images[j];

        img.id = getAsset(images[j], "materials/" + json[i].type);
        img.classList.add("galleryImage");
        img.src = img.id;
        img.setAttribute("itemType", "galleryTexture");
        list.appendChild(img);
      }
    }
  }
  show() {
    document.body.appendChild(this.gallery);
    this.gallery.style.display = "flex";
    setTimeout(() => {
      this.galleryBox.classList.add("show");
    }, 10);
  }
  hide() {
    this.galleryBox.classList.remove("show");
  }
  appendTo(parent) {
    if (parent instanceof HTMLElement) {
      parent.appendChild(this.gallery);
    } else {
      console.error("Invalid parent element. It must be an HTMLElement.");
    }
  }
}
